//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

//Clinic Recalls
const getClinicSettings = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/settings")
}
const saveSettings = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/settings",data)
}
const getClinicTimings= (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/recall-timings")
}
const saveClinicTimings= (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/recall-timings",data)
}

//Admin Recalls

const getRecallRequests = (pageNo = 0, pageSize = 10, filterOptions = {}) => {
    const { title, status, clinic } = filterOptions;
    return axios.get(API_URL + 'recalls/requests', {
        params: {
            pageNo,
            pageSize,
            ...(title && { title }),
            ...(status && { status }),
            ...(clinic && { clinic }),
        },
    });
};

const getRecalls = (pageNo = 0, pageSize = 10, status, title, filterOptions = {}) => {
    return getRecallRequests(pageNo, pageSize, { title, status, ...filterOptions });
};
const getRecallsById = (recallId) => {
    return axios.get(API_URL + 'recalls/requests/' + recallId);
};

const getRecallRequestById = (recallId) => getRecallsById(recallId);

const updateRecall = (recallId, data) => {
    return axios.put(API_URL + 'recalls/requests/' + recallId, data);
};

const updateRecallRequestById = (recallId, data) => updateRecall(recallId, data);

const downloadRecallRequestFile = (clinicId, reqId) => {
    return axios.get(API_URL + `recalls/${clinicId}/requests/${reqId}/downloads`, {
        responseType: 'blob',
    });
};

const uploadRecallFileToProcess = (reqId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(API_URL + `recalls/requests/${reqId}/file-to-process`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

const fileDownload = (fileUrl) => {
    return axios.get(fileUrl, {
        responseType: 'blob',
    });
};
export default {
   getClinicSettings,
   saveSettings,
   getClinicTimings,
   saveClinicTimings,
   getRecalls,
   getRecallRequests,
   getRecallsById,
   getRecallRequestById,
   updateRecall,
   updateRecallRequestById,
   downloadRecallRequestFile,
   uploadRecallFileToProcess,
   fileDownload,

}